import React from "react";
import ModalReportStyles from "../../../../styles/pages/Summaries/ModalReportStyles";

interface IHeader {
    title?: string;
    subtitle?: string;
}

const { StyledModalTitle, StyledModalSubTitle } = ModalReportStyles;

const HeaderTachModal: React.FC<IHeader> = ({ title, subtitle }) => {
    return (
        <>
            <StyledModalTitle>{title}</StyledModalTitle>
            <StyledModalSubTitle>{subtitle}</StyledModalSubTitle>
        </>
    );
};

export default HeaderTachModal;
